import React, { Component } from 'react'
import CodeMirrorBase from 'codemirror'
import { Controlled as Codemirror } from 'react-codemirror2'
import 'codemirror/mode/markdown/markdown'
import 'codemirror/addon/mode/overlay'
import 'codemirror/addon/display/placeholder'
import spellcheck from 'codemirror-spell-checker'

import Checkbox from '../components/ncss/Checkbox.js'

spellcheck({
  codeMirrorInstance: CodeMirrorBase
})

export default class MarkdownEditor extends Component {
  constructor (...props) {
    super(...props)
    this.state = {
      isSpellCheckActive: false
    }
  }
  handleChange = (editor, data, value) => {
    this.props.onChange(value)
  }
  setSpellCheck = (value) => {
    this.setState({isSpellCheckActive: value})
  }
  render () {
    let { value, placeholder, className } = this.props
    let { isSpellCheckActive } = this.state

    const codeMirrorOptions = {
      mode: isSpellCheckActive ? 'spell-checker' : 'markdown',
      backdrop: 'markdown',
      lineWrapping: true,
      placeholder,
      viewportMargin: Infinity
    }

    return (
      <div className={className}>
        <div className='markdown-controls editor-controls'>
          <Checkbox checked={isSpellCheckActive}
            onChange={this.setSpellCheck}
            label='Spell Check' />
        </div>
        <Codemirror options={codeMirrorOptions}
          value={value}
          onBeforeChange={this.handleChange} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/src/components/MarkdownEditor.js